function isDataRow(row) {
  return row && !row.isTotal;
}

function sumProfilesBy(rows, getKey, predicate = () => true) {
  const totals = new Map();

  rows.filter(isDataRow).filter(predicate).forEach((row) => {
    const key = String(getKey(row) || '').trim();
    if (!key || key === '—') return;
    totals.set(key, (totals.get(key) || 0) + (row.profilesSourced || 0));
  });

  return [...totals.entries()]
    .map(([label, count]) => ({ label, count }))
    .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label));
}

export function aggregateProfilesSourcedCharts(rows = []) {
  return {
    byRecruiterAndTeamLead: sumProfilesBy(
      rows,
      (row) => row.name,
      (row) => row.role === 'Recruiter' || row.role === 'Team Lead'
    ),
    byClient: sumProfilesBy(rows, (row) => row.client),
  };
}

export function getBarChartAxisMax(maxCount) {
  const max = Math.max(maxCount, 0);
  if (max <= 0) return 1;
  if (max <= 4) return 4;
  if (max <= 8) return 8;
  if (max <= 10) return 12;
  const step = max <= 20 ? 4 : max <= 50 ? 10 : 20;
  return Math.ceil(max / step) * step;
}

export function buildAxisTicks(axisMax, tickCount = 5) {
  if (axisMax <= 0) return [0];
  const safeTickCount = Math.max(tickCount, 2);
  const step = axisMax / (safeTickCount - 1);
  return Array.from({ length: safeTickCount }, (_, index) => Math.round(step * index));
}
